
export const AppMenus = {

  navbarTopRightItems: [],
  navbarTopLeftItems: [],
  navbarSideLeftItems: [
    {
      "to": "/home",
      "label": "Home",
      "icon": "pi pi-home text-blue-900",
      "iconcolor": "",
      "target": "",

    },
    {
      "to": "/customers",
      "label": "Customers",
      "icon": "pi pi-user text-blue-900",
      "iconcolor": "",
      "target": "",

    },
    {
      "to": "/complaints",
      "label": "Complaints",
      "icon": "pi pi-file-excel text-blue-900",
      "iconcolor": "",
      "target": "",

    },
    {
      "to": "/feeds",
      "label": "Messages",
      "icon": "pi pi-envelope text-blue-900",
      "iconcolor": "",
      "target": "",

    },
    // {
    //   "to": "/payment_history",
    //   "label": "App Transactions",
    //   "icon": "pi pi-money-bill text-blue-900",
    //   "iconcolor": "",
    //   "target": "",

    // },
    // {
    //   "to": "",
    //   "label": "E-Billing",
    //   "icon": "pi pi-database text-blue-900",
    //   "iconcolor": "",
    //   "target": "",
    //   "items": [
    //     {
    //       "to": "/ebilling/customers",
    //       "label": "Manage Customers",
    //       "icon": "pi pi-user text-blue-900",
    //       "iconcolor": "",
    //       "target": "",
    //     },
    //     {
    //       "to": "/ebilling/statements",
    //       "label": "Statement Reports",
    //       "icon": "pi pi-file-pdf text-blue-900",
    //       "iconcolor": "",
    //       "target": "",

    //     }
    //   ],
    // },
    // {
    //   "to": "/offices",
    //   "label": "Offices",
    //   "icon": "pi pi-building text-blue-900",
    //   "iconcolor": "",
    //   "target": "",
    // },
    {
      "to": "/region_districts",
      "label": "Region Districts",
      "icon": "pi pi-map-marker text-blue-900",
      "iconcolor": "",
      "target": "",

    },
    {
      "to": "/users",
      "label": "User Accounts",
      "icon": "pi pi-users text-blue-900",
      "iconcolor": "",
      "target": "",

    },
    {
      "to": "/user_roles",
      "label": "Roles & Permissions",
      "icon": "pi pi-user-edit text-blue-900",
      "iconcolor": "",
      "target": "",

    },
    {
      "to": "/reports",
      "label": "Reports",
      "icon": "pi pi-chart-pie text-blue-900",
      "iconcolor": "",
      "target": "",
    }
  ],
  feedTypeItems: [
    { value: "annoucement", label: "Annoucement" },
    { value: "update", label: "Update" },
    { value: "emergency", label: "Emergency" },
    { value: "greetings", label: "Greetings" },
    { value: "tip", label: "Tip" },
    { value: "article", label: "Article" },
    { value: "other", label: "Other" }
  ],
  date_filterItems: [
    { "label": "Today", "value": "Today" },
    { "label": "Yesterday", "value": "Yesterday" },
    { "label": "Last 3 Days", "value": "Last 3 Days" },
    { "label": "Last 7 Days", "value": "Last 7 Days" },
    { "label": "Last 30 Days", "value": "Last 30 Days" },
    { "label": "Last 60 Days", "value": "Last 60 Days" },
    { "label": "Last 90 Days", "value": "Last 90 Days" },
    { "label": "Only This Year", "value": "Only This Year" },
    { "label": "Last Year", "value": "Last Year" },
    { "label": "2 Years Ago", "value": "2 Years Ago" },
    { "label": "3 Years Ago", "value": "3 Years Ago" },
    { "label": "All", "value": "All" },
  ],
  complaintTypeItems: [
    { value: "complex tariff structure", label: "C01 - Complex tariff structure" },
    { value: "estimated water bills", label: "C02 - Estimated water bills" },
    { value: "over-billing", label: "C03 - Over-Billing" },
    { value: "late or no delivery of bills", label: "C04 - Late or No delivery of bills" },
    { value: "unreflected payment", label: "CO5 - Unreflected Payment" },
    { value: "pipe burst", label: "C06 - Pipe Burst" },
    { value: "leakage", label: "C07 - Pipe Leakage" },
    { value: "no flow", label: "C08 - No Flow" },
    { value: "low pressure", label: "C09 - Low pressure" },
    { value: "quality of water", label: "C10 - Quality of water" },
    { value: "incorrect meter reading", label: "C11 - Incorrect meter reading" },
    { value: "faulty meter", label: "C12 - Faulty Meter" },
    { value: "stolen meters", label: "C13 - Stolen meters" },
    { value: "illegal connection", label: "C14 - Illegal Connection" },
    { value: "wrong disconnection", label: "C15 - Wrong disconnection" },
    { value: "delay in connecting customers", label: "C16 - Delay in connecting customers" },
    { value: "high estimate costs new service connections", label: "C17 - High estimate costs new service connections" },
    { value: "wrong categorization of customers", label: "C18 - Wrong categorization of customers" },
    { value: "poor accessibility to company", label: "C19 - Poor accessibility to company" },
    { value: "Untimely response to complaints", label: "C20 - Untimely response to complaints" },
    { value: "request for general information", label: "C21 - Request for general information" },
    { value: "request for customer statement", label: "C22 - Request for customer statement" },
    { value: "wrong customer information on bill", label: "C23 - Wrong customer information on bill" },
    { value: "incorrect balancing on bill", label: "C24 - Incorrect balancing on bill" },
    { value: "billed after disconnection", label: "C25 - Billed after disconnection" },
    { value: "enquiry", label: "C26 - Enquiry" },
  ],
  actionTakenItems: [
    { value: "Explained to customer", label: "A1 - Explained to customer" },
    { value: "Repaired", label: "A2 - Repaired" },
    { value: "Adjustment", label: "A3 - Adjustment" },
    { value: "Advised to purchase meter", label: "A4 - Advised to purchase meter" },
    { value: "Penalty", label: "A5 - Penalty" },
    { value: "Reconnection effected", label: "A6 - Reconnection effected" },
    { value: "Disconnection effected", label: "A7 - Disconnection effected" },
    { value: "Assigned to Region District", label: "A8 - Assigned to Region District" },
    { value: "No Action Taken", label: "A9 - No Action Taken" },
    // { value: "Forwarded to developers", label: "Forward To Developers" }
  ],
  regionItems: [
    { value: "Ashanti", label: "Ashanti" },
    { value: "Brong Ahafo", label: "Brong Ahafo" },
    { value: "Central", label: "Central" },
    { value: "Eastern", label: "Eastern" },
    { value: "Greater Accra", label: "Greater Accra" },
    { value: "Northern", label: "Northern" },
    { value: "Upper East", label: "Upper East" },
    { value: "Upper West", label: "Upper West" },
    { value: "Volta", label: "Volta" },
    { value: "Western", label: "Western" },
    { value: "Ahafo", label: "Ahafo" },
    { value: "Bono East", label: "Bono East" },
    { value: "Bono", label: "Bono" },
    { value: "North East", label: "North East" },
    { value: "Oti", label: "Oti" },
    { value: "Savannah", label: "Savannah" },
    { value: "Front Office", label: "Front Office" },
    { value: "Ghana Water", label: "Ghana Water" },
  ],
  gwclRegionItems: [
    { value: "Accra East", label: "Accra East" },
    { value: "Accra West", label: "Accra West" },
    { value: "Ashanti North", label: "Ashanti North" },
    { value: "Ashanti South", label: "Ashanti South" },
    { value: "Brong Ahafo", label: "Brong Ahafo" },
    { value: "Central", label: "Central" },
    { value: "Eastern", label: "Eastern" },
    { value: "Northern", label: "Northern" },
    { value: "Tema", label: "Tema" },
    { value: "Upper East", label: "Upper East" },
    { value: "Upper West", label: "Upper West" },
    { value: "Volta", label: "Volta" },
    { value: "Western", label: "Western" },
    { value: "Front Office", label: "Front Office" },
    { value: "Ghana Water", label: "Ghana Water" },
  ],
  complaintsStatusItems: [
    { "label": "Open", "value": "opened" },
    { "label": "In Progress", "value": "in progress" },
    { "label": "Close", "value": "closed" },
    { "label": "Assigned", "value": "assigned" },
    { "label": "On Hold", "value": "on hold" },
    { "label": "Prank", "value": "prank" }
  ],
  complaintsSeverityItems: [{ "label": "Low", "value": "Low" }, { "label": "Medium", "value": "Medium" }, { "label": "High", "value": "High" }],
  complaintsSourceOfComplaintItems: [
    { value: "Call Center", label: "Call Center" },
    { value: "Walk-In", label: "Walk-In" },
    { value: "PR Department", label: "PR Department" },
  ],
  statementReportTypesItems: [
    { value: "current_bill", label: "Current Bill" },
    { value: "billing", label: "Monthly Billing Report" },
    { value: "statement", label: "Customer Account Statement" },
  ],
  channelTypesItems: [
    { value: "app", label: "Mobile App" },
    { value: "sms", label: "SMS" },
    { value: "email", label: "Email" },
  ],
  customerServiceScriptsItems: [
    { label: "Greeting  a customer for the first time", value: "Welcome to Customer Service. My name is <YourName>. How can I help you?" },
    { label: "Greeting a repeat customer", value: "Welcome back, <CustomerName>. I hope you are doing well. Are you still facing the same issue with our service?" },
    { label: "Sharing proactive apologies", value: "Hi <CustomerName>, our associated payment gateway provider has unfortunately experienced a server crash. We are extremely sorry for the inconvenience caused and will update you as soon as the problem is resolved" },
    { label: "Apologizing with empathy", value: "I totally understand where you are coming from. I am extremely sorry to hear that you had to go through this . I would feel frustrated too in that situation" },
    { label: "Apologizing with a commitment", value: "I am extremely sorry for all the problems you’ve been facing lately with our service. I’m going to make sure that we get this taken care of today" },
    { label: "Asking customers to provide feedback", value: "We are glad to hear that your has been resolved. Would you mind sharing your feedback? Your feedback will help us improve further" },
    { label: "Requesting for some time", value: "Kindly allow me some time so that I can quickly scan through our internal help articles to help you with your current " },
  ],
  customerStatus: [
    { value: "Active", label: "Active" },
    { value: "Dormant", label: "Dormant" },
    { value: "Inactive", label: "Inactive" },
  ],
  exportFormats: {
    print: {
      label: 'Print',
      icon: 'pi pi-print',
      type: 'print',
      ext: '',
    },
    pdf: {
      label: 'Pdf',

      icon: 'pi pi-file-pdf',
      type: 'pdf',
      ext: 'pdf',
    },
    excel: {
      label: 'Excel',
      icon: 'pi pi-file-excel',
      type: 'excel',
      ext: 'xlsx',
    },
    csv: {
      label: 'Csv',
      icon: 'pi pi-table',
      type: 'csv',
      ext: 'csv',
    },
  },

}